export default __webpack_public_path__ + "static/media/da_app_honu_256.f8c146b1.ico";